<template>
  <ul class="rounded bg-gray-500 flex flex-col overflow-hidden">
    <button class="button bg-zoom-in-white"
            @click="zoom(0.1)"
    ></button>
    <button class="button border-t border-gray-100 bg-zoom-out-white"
            @click="zoom(-0.1)"
    ></button>
    <button class="button border-t border-gray-100 bg-zoom-fit-white"
            @click="zoom('fit')"
    ></button>
    <button class="button border-t border-gray-100 bg-zoom-ori-white"
            @click="zoom('ori')"
    ></button>
  </ul>
</template>

<script>
export default {
  name: 'RoomDocZoom',
  methods: {
    zoom(type) {
      const csCanvas = this.$parent.$refs.csCanvas;
      switch (type) {
        case 'fit': csCanvas.zoomFit(); break
        case 'ori': csCanvas.zoomOri(); break
        default: csCanvas.zoom(type); break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  @apply w-9 h-9 transition hover:bg-gray-700;
}
</style>